import { useThemeSlice } from "../../../components/ui/StatusBadge.jsx";
import { sidebarPrimaryButton } from "../../../components/ui/buttonStyles.js";
import { SearchField } from "../../../components/ui/SearchField.jsx";
import { Ico } from "../../../components/icons/icons.jsx";
import { SidebarEmptyHint } from "../../../components/emptyStates/SidebarEmptyHint.jsx";
import { DeviceListSkeleton } from "../../../components/skeletons/DeviceListSkeleton.jsx";
import { deriveAssetDisplayName } from "../assetUtils.js";

export function AssetSidebar({
  assets,
  selectedId,
  onSelect,
  search,
  onSearchChange,
  onCreate,
  loading,
  getAssetTypeName,
  getAssetSubtitle,
  getAssetType,
}) {
  const { c, dark, accentHex: A } = useThemeSlice();

  return (
    <aside style={{ width: 280, flexShrink: 0, display: "flex", flexDirection: "column", borderRight: `1px solid ${c.cardBdr}`, background: c.sb, minHeight: 0 }}>
      <div style={{ padding: "12px 14px 10px", flexShrink: 0, borderBottom: `1px solid ${c.cardBdr}` }}>
        <SearchField value={search} onChange={onSearchChange} placeholder="Search assets…" ariaLabel="Search assets" variant="sidebar" />
      </div>

      <div style={{ flex: 1, overflow: "auto", padding: "2px 10px 10px", minHeight: 0 }}>
        {loading ? (
          <DeviceListSkeleton />
        ) : assets.length === 0 ? (
          <SidebarEmptyHint c={c}>{search.trim() ? "No matching assets" : "No assets yet"}</SidebarEmptyHint>
        ) : (
          assets.map((asset) => {
            const active = asset.id === selectedId;
            const typeName = getAssetTypeName(asset.assetTypeId);
            const assetType = getAssetType?.(asset.assetTypeId);
            const displayName = deriveAssetDisplayName(asset, assetType);
            return (
              <button
                key={asset.id}
                type="button"
                onClick={() => onSelect(asset.id)}
                style={{
                  width: "100%",
                  display: "flex",
                  alignItems: "flex-start",
                  gap: 10,
                  textAlign: "left",
                  padding: "10px 12px",
                  marginBottom: 6,
                  borderRadius: 8,
                  border: `1px solid ${active ? `${A}55` : c.cardBdr}`,
                  borderLeft: active ? `3px solid ${A}` : `1px solid ${c.cardBdr}`,
                  background: active ? (dark ? `${A}10` : `${A}06`) : c.hover,
                  color: c.text,
                  cursor: "pointer",
                  boxShadow: active && !dark ? "0 1px 2px rgba(0,0,0,.04)" : "none",
                }}
              >
                <div style={{ flex: 1, minWidth: 0 }}>
                  <div style={{ fontSize: 13, fontWeight: active ? 700 : 600, color: c.text, lineHeight: 1.3 }}>{displayName}</div>
                  <div style={{ fontSize: 11, color: c.sub, marginTop: 3, lineHeight: 1.35 }}>{getAssetSubtitle(asset)}</div>
                </div>
                <span style={{ flexShrink: 0, fontSize: 9.5, fontWeight: 800, letterSpacing: "0.04em", textTransform: "uppercase", color: A, background: dark ? `${A}22` : `${A}12`, border: `1px solid ${dark ? `${A}40` : `${A}28`}`, borderRadius: 999, padding: "3px 7px", marginTop: 2 }}>
                  {typeName}
                </span>
              </button>
            );
          })
        )}
      </div>

      <div style={{ padding: "12px 14px 14px", flexShrink: 0, borderTop: `1px solid ${c.divider}`, background: c.sb }}>
        <button type="button" onClick={onCreate} style={sidebarPrimaryButton(A, dark)}>
          {Ico.plus}
          Create asset
        </button>
      </div>
    </aside>
  );
}
